module.exports = __webpack_public_path__ + "img/single-vel-btn2.6137f058.png";